import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import PropTypes from "prop-types";
import { MdSearch } from "react-icons/md";
import DataTable from "../../Shared/DataTable";
import CardStatusFilter from "./CardStatusFilter";

export class CardStatusList extends Component {
  render() {
    const columns = [
      /* {
        Header: "Id",
        accessor: "id"
      }, */
      {
        Header: "Card Pan (Masked)",
        accessor: "panMasked"
      },
      {
        Header: "Domain",
        accessor: "domain"
      },
      {
        Header: "Institution",
        accessor: "institution"
      },
      {
        Header: "Wallet",
        accessor: "walletName"
      },
      {
        Header: "Wallet Status",
        accessor: "walletStatus"
      },
      {
        Header: "Card Status",
        accessor: "cardStatus"
      }
    ];

    const { match, fetching, data, loadData } = this.props;

    return (
      <div>
        <h4 className="item-count">
          <MdSearch /> Search Card Status
        </h4>
        <CardStatusFilter loadData={loadData} />
        <hr />
        <Row>
          <Col sm="6">
            <h5 className="item-count">
              {data ? data.count : "0"} Result(s) Found
            </h5>
          </Col>
        </Row>
        <hr />
        <DataTable
          columns={columns}
          loading={fetching}
          urlParams={match}
          data={data && data.modelList ? data.modelList : []}
          defaultPageSize={10}
          hideButtons={true}
        />
      </div>
    );
  }
}

CardStatusList.proptypes = {
  match: PropTypes.object.isRequired,
  data: PropTypes.object,
  loadData: PropTypes.func,
  fetching: PropTypes.bool,
  fetched: PropTypes.bool,
  error: PropTypes.object
};

export default CardStatusList;
